import React from 'react';
import {PromotionBannerModel} from "../../models/promotion-banner/promotion-banner-model";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {Image} from "../image/image";
import {Link} from "../link/link";
import styles from './promotion-banner.module.scss';
import classnames from "classnames";
import {PromotionBannerComposer} from "./promotion-banner.composer";

class QuizBannerProps extends BaseProps {
  model: PromotionBannerModel;
}

export const PromotionBanner = PromotionBannerComposer(({className, linkModel, imageUrl, isSmallView}: QuizBannerProps) => {
  const linkProps = {
    model: linkModel,
    className: classnames(styles.container, className, {[styles.small_view]: isSmallView})
  }

  const imageProps = {
    src: imageUrl,
    style: {
      width: '100%',
      height: 'auto'
    }
  }

  return <Link {...linkProps}>
    <Image {...imageProps}/>
  </Link>
});
